

import { 
    NotificationChannel,
  } from '@/types/notification'

  
export const useMessages = () => {

    if(!useAuth().isAuth()) {
        useToast().error('You need to be logged in to open messages')
        useRouter().push('/auth/signin')
        return
    }


    const jumpAddressId = useState('jumpAddressId', () => null as number | null)

    useCook('notification_active_tab').value = NotificationChannel.Messages
    
    const openMessages = (addressId: number) => {

        if (!useAuth().getAccess('view_extra')) {
            useNuxtApp().hooks.callHook('chat:start', addressId).catch(() => {
                console.log('chat:start hook');    
            })
        }else{
            jumpAddressId.value = addressId
            useRouter().push('/notifications')
        }
    }

    return {
        openMessages,
        jumpAddressId
    }
  }
  